import { useMemo, useEffect } from 'react';

import { useAppSelector } from 'application/providers/StoreProvider';

import useBusinessSpheres from 'domain/auth/useBusinessSpheres';

import { useAccountSelectors } from './account/useAccountSelectors';
import { useAccountCompanyId } from './account/useAccountCompanyId';
import { useAccountIsReadyToUseLK } from './account/useAccountIsReadyToUseLK';

const useGetCurrentBusinessSphere = () => {
  const selectors = useAccountSelectors();

  const companyId = useAccountCompanyId();
  const isReadyToUseLK = useAccountIsReadyToUseLK();

  const currentUser = useAppSelector(selectors.selectUserData);
  const currentCompany = useAppSelector(selectors.selectMainCompanyData);

  const { request, businessSpheres } = useBusinessSpheres();

  const currentBusinessSphere = useMemo(
    () => (businessSpheres || []).find((item) => item.id === currentCompany?.businessSphereId),
    [businessSpheres, currentCompany?.businessSphereId]
  );

  useEffect(() => {
    if (currentUser?.id && companyId && isReadyToUseLK) {
      request();
    }
  }, [currentUser?.id, companyId, isReadyToUseLK]);

  return {
    request,
    businessSpheres,
    currentBusinessSphere,
  };
};

export default useGetCurrentBusinessSphere;
